<template>
  <b-card class="product-card h-100" no-body>
    <div class="product-image-wrapper">
      <b-card-img
        :src="productImage"
        :alt="product.name"
        class="product-image"
        @click="goToDetail"
        @error="onImageError">
      </b-card-img>
      <b-badge v-if="product.featured" variant="danger" class="featured-badge">
        Destacado
      </b-badge>
      <b-badge v-if="!product.stock || product.stock <= 0" variant="warning" class="stock-badge">
        Sin Stock
      </b-badge>
    </div>
    
    <b-card-body class="d-flex flex-column">
      <b-card-title class="product-title">
        {{ product.name }}
      </b-card-title>
      
      <b-card-text class="text-muted small mb-2">
        {{ product.brand ? product.brand.name : '' }}
      </b-card-text>
      
      <b-card-text class="product-description flex-grow-1">
        {{ truncateText(product.description, 100) }}
      </b-card-text>
      
      <div class="price-section mb-3">
        <h4 class="price mb-0" v-if="showPrice">
          ${{ formatPrice(product.price) }}
        </h4>
        <small v-if="product.original_price && product.original_price > product.price" class="text-muted">
          <del>${{ formatPrice(product.original_price) }}</del>
          <b-badge variant="success" class="ml-1">
            -{{ calculateDiscount(product.price, product.original_price) }}%
          </b-badge>
        </small>
      </div>
      
      <div class="action-buttons">
        <b-button 
          variant="primary" 
          size="sm"
          @click="goToDetail"
          block>
          Ver Detalle
        </b-button>
        <b-button 
          v-if="canAddToCart"
          variant="success" 
          size="sm"
          @click="addToCart"
          :disabled="!hasStock"
          block
          class="mt-2">
          <b-icon icon="cart-plus"></b-icon>
          Agregar al Carrito
        </b-button>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    productImage() {
      if (this.product.images && this.product.images.length > 0) {
        return this.product.images[0]
      }
      return require('@/assets/images/product-placeholder.svg')
    },
    showPrice() {
      const config = this.$store.getters.shopConfig
      return config && (config.show_public_prices || this.$store.getters.isAuthenticated)
    },
    canAddToCart() {
      const config = this.$store.getters.shopConfig
      return config && (config.allow_sale_unlogged || this.$store.getters.isAuthenticated)
    },
    hasStock() {
      const config = this.$store.getters.shopConfig
      if (config && config.sale_without_stock) {
        return true
      }
      return this.product.stock && this.product.stock > 0
    }
  },
  methods: {
    truncateText(text, length) {
      if (!text) return ''
      if (text.length <= length) return text
      return text.substring(0, length) + '...'
    },
    formatPrice(price) {
      return new Intl.NumberFormat('es-AR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(price)
    },
    calculateDiscount(price, originalPrice) {
      return Math.round(((originalPrice - price) / originalPrice) * 100)
    },
    goToDetail() {
      this.$router.push({ 
        name: 'ProductDetail', 
        params: { id: this.product.id }
      })
    },
    onImageError(e) {
      e.target.src = require('@/assets/images/product-placeholder.svg')
    },
    addToCart() {
      this.$store.dispatch('addToCart', {
        id: this.product.id,
        name: this.product.name,
        price: this.product.price,
        image: this.productImage,
        quantity: 1
      })
      
      this.$bvToast.toast('Producto agregado al carrito', {
        title: 'Éxito',
        variant: 'success',
        solid: true,
        autoHideDelay: 3000
      })
    }
  }
}
</script>

<style scoped>
.product-card {
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.product-image-wrapper {
  position: relative;
  overflow: hidden;
  height: 250px;
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.product-card:hover .product-image {
  transform: scale(1.05);
}

.featured-badge {
  position: absolute;
  top: 10px;
  right: 10px;
}

.stock-badge {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.product-title {
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.3;
  min-height: 2.6rem;
}

.product-description {
  font-size: 0.9rem;
  color: #666;
}

.price {
  color: #28a745;
  font-weight: bold;
}
</style>